import { ethereum } from '@0xtorch/core'
import { abstract } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createAbstractChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createAbstractChainCustom({
    client: createClient({ chain: abstract, httpRpcs: abstractHttpRpcs }),
    explorer: createEtherscanV2({
      name: 'Abscan',
      baseUrl: 'https://abscan.org',
      chainId: 2741,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateAbstractChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createAbstractChainCustom = ({
  client,
  explorer,
}: CreateAbstractChainCustomParameters): Chain => ({
  id: 2741,
  network: 'abstract',
  name: 'Abstract',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x3439153eb7af838ad19d56e1571fbd09333c2809',
  ]),
  explorer,
  client,
  blockTime: 1000,
  coingeckoId: 'abstract',
  defillamaId: undefined,
})

export const abstractHttpRpcs: HttpRpc[] = [
  {
    url: 'https://api.mainnet.abs.xyz',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://abstract.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://abstract.api.onfinality.io/public',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://abstract-mainnet.gateway.tatum.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const abstractWebsocketRpcUrls: string[] = ['wss://abstract.drpc.org']
